import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import AddCausePrincipaleDialog from './AddCausePrincipaleDialog';

import DeleteCausePrincipaleDialog from './DeleteCausePrincipaleDialog';
import { green } from '@mui/material/colors';



const styles = theme => ({
    root: {
        margin: 0,
        padding: 0
    },
    table: {
        //minWidth: 700
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link, 
       
    administrationHeaderContainer: {
        display: 'flex',
        width: '100%'
    },
    administrationHeaderItemLeft: {
        flex: '1 1 auto'
    },
    administrationHeaderItemRight: {
        flex: '0 1 auto'
    },

    deleting: {
        background : 'red'
    }

});



class AdministrationCausesPrincipales extends React.Component {
    

    render() {

        let {
            classes, causesPrincipales,
            addCausePrincipaleDialogOpen, onOpenAddDialog, onCloseAddDialog, addCausePrincipale,
            deleteCausePrincipaleDialogOpen, onOpenDeleteDialog, onCloseDeleteDialog, deleteCausePrincipale, causePrincipaleToDelete
         } = this.props;

        return (
            <React.Fragment>

                {addCausePrincipaleDialogOpen && <AddCausePrincipaleDialog onClose={onCloseAddDialog} onClickSave={addCausePrincipale} />}
                {deleteCausePrincipaleDialogOpen && <DeleteCausePrincipaleDialog onClose={onCloseDeleteDialog} onClickDelete={deleteCausePrincipale} causePrincipale={causePrincipaleToDelete} />}


                <div className={classes.administrationHeaderContainer}>
                    <Typography gutterBottom variant="h5" className={classes.administrationHeaderItemLeft}>
                        Administration des causes principales
                    </Typography>
                    <Button className={classes.administrationHeaderItemRight} onClick={onOpenAddDialog}>Nouvelle</Button>
                </div>

                <Paper className={classes.root}>

                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell align='right'>Id</TableCell>
                                <TableCell>Code</TableCell>
                                <TableCell>Libellé</TableCell>
                                <TableCell>Nb actions</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {causesPrincipales.sort((a,b) => a.code > b.code).map(causePrincipale => {
                                return (
                                    <TableRow key={causePrincipale.id} className={causePrincipaleToDelete && causePrincipaleToDelete.id === causePrincipale.id ? classes.deleting :''}
                                        hover
                                    >
                                        <TableCell component="th" scope="row" align='right'>
                                            <Link to={`/administration/causesPrincipales/${causePrincipale.id}`} className={classes.link}>
                                                <Typography variant="button">
                                                    {causePrincipale.id}
                                                </Typography>
                                            </Link>
                                        </TableCell>
                                        <TableCell>{causePrincipale.code}</TableCell>
                                        <TableCell>{causePrincipale.libelle}</TableCell>
                                        <TableCell>{causePrincipale.nbActions}</TableCell>
                                        <TableCell>
                                            <Button disabled={causePrincipale.nbActions > 0} onClick={e => onOpenDeleteDialog(causePrincipale.id)}>Supprimer</Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>

                </Paper>

            </React.Fragment>


        );
    }
}

AdministrationCausesPrincipales.propTypes = {
    classes: PropTypes.object.isRequired,
    causesPrincipales: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationCausesPrincipales);